import React from 'react';
import classNames from 'classnames';
import { useTheme } from '@components/theme';
import Chevron from './up-arrow.svg';
import styles from './ScrollToTopButton.module.scss';

interface IScrollToTopButtonProps {
  className?: string;
  onClick?: () => void;
  visible?: boolean;
}

const ScrollToTopButton = ({
  className = '',
  visible = true,
  onClick = () => {},
}: IScrollToTopButtonProps) => {
  const theme = useTheme();
  return (
    <button
      className={classNames(
        className,
        styles.ScrollToTop,
        {
          [styles.Visible]: visible,
          [styles.Hidden]: !visible
        }
      )}
      title="Back to top of the page"
      style={{
        backgroundColor: theme.colors.core8
      }}
      type="button"
      onClick={onClick}
    >
      <Chevron />
    </button>
  );
};

export default ScrollToTopButton;
